import axios from 'axios';
import Swal from 'sweetalert2';
import { SERVER_BASE } from '../config/server';

// Create an Axios instance
const apiClient = axios.create({
  baseURL: SERVER_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a response interceptor
apiClient.interceptors.response.use(
  (response) => response, // Pass through successful responses
  (error) => {
    if (error.response) {
      if (error.response.status === 401) { // Handle 401 Unauthorized specifically
        Swal.fire({
          icon: 'error',
          title: 'Session Expired',
          text: 'Your session has expired. Please log in again.',
          showConfirmButton: true,
        }).then((result) => {
          if (result.isConfirmed) {
            localStorage.clear()
            window.location.href = '/'; // Redirect to login page only after confirmation
          }
        });
      }
    }
    return Promise.reject(error); // Reject the error for further handling if needed
  }
);

export default apiClient;
